module.exports = __webpack_public_path__ + "../assets/img/196f60132eb009ff5ed78392dfcb74db.png";